import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import FileDateUser from './DateUser';

import { getShare } from '../../helpers/Auth';

const FileDate = ({ file, fileVersion }) => {
  const intl = useIntl();

  return (
    <>
      {file.type !== 'link' && (
        <>
          <FileDateUser
            id={`${file.uuid}-c`}
            date={file.original_datetime}
            title="Created"
          />
          <br />
        </>
      )}
      {(!getShare() && !fileVersion) && (
        <FileDateUser
          id={file.uuid}
          user={file.user}
          date={file.created_at}
          title={file.type === 'link' ? intl.formatMessage({ defaultMessage: 'Added' }) :
            intl.formatMessage({ defaultMessage: 'Uploaded' })}
          file={file}
        />
      )}
      {file.version_created_at && (
        <>
          {(!getShare() && !fileVersion) && (
            <br />
          )}
          <FileDateUser
            id={`${file.uuid}-v`}
            user={file.version_user}
            date={file.version_created_at}
            title={fileVersion ? intl.formatMessage({ defaultMessage: 'Uploaded' }) :
              intl.formatMessage({ defaultMessage: 'Updated' })}
          />
        </>
      )}
    </>
  );
};

FileDate.propTypes = {
  file: PropTypes.object.isRequired,
  fileVersion: PropTypes.number,
};

FileDate.defaultProps = {
  fileVersion: null,
};

export default FileDate;
